import { useEffect, useState } from "react";
import { Wind, Thermometer, Sun, Flame, Snowflake, House, Droplet, Heater, Fan, Zap, Plug, Wrench, Box } from "lucide-react";
import api from "./api";

/**
 * Technologie (kategorie): výchozí ProfitPilotu + vlastní firmy (Nastavení → Technologie).
 * Ikona se ukládá jako klíč — tady je jediné místo, kde se mapuje na obrázek.
 */
export const IKONY_TECHNOLOGII = {
  wind: Wind, thermometer: Thermometer, sun: Sun, flame: Flame, snowflake: Snowflake, house: House,
  droplet: Droplet, heater: Heater, fan: Fan, zap: Zap, plug: Plug, wrench: Wrench, box: Box,
};

export const ikonaTechnologie = (klic) => IKONY_TECHNOLOGII[klic] || Box;

/** Zkratka na štítek (REK, TČ…); vlastní technologie bez zkratky → první 3 písmena. */
export const zkratkaTechnologie = (k) => (k?.zkratky || (k?.name || "").slice(0, 3)).toUpperCase();

/** Technologie firmy (výchozí + vlastní) — jednou za načtení stránky. */
export function useTechnologie() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    let zivy = true;
    api.get("/api/meta/ciselniky").then(({ data }) => { if (zivy) setItems(data.kategorie || []); }).catch(() => { if (zivy) setItems([]); });
    return () => { zivy = false; };
  }, []);
  return items;
}
